import { createBrowserRouter } from "react-router-dom";
import { publiRoutes } from "./public";
import { privateRoutes } from "./private";

export const router = createBrowserRouter([
  ...publiRoutes,
  ...privateRoutes
]);
